/* eslint-disable no-console */
import { toast } from 'react-toastify';
import api from './api';

export const excelExport = (url, documentName, callBackSucess, callBackFail) =>
  api
    .get(url, {
      headers: {
        'Content-Disposition': 'attachment; filename=template.xlsx',
        'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    })
    .then((response) => {
      const redirect = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = redirect;
      link.setAttribute('download', `${documentName}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success('Fazendo Download do arquivo...');
      if (callBackSucess) callBackSucess();
    })
    .catch((error) => {
      toast.error('Erro ao Fazer Download do Arquivo');
      if (callBackFail) callBackFail();
    });

export const Pdf = async (url, documentName, thenCallBack) =>
  api
    .get(url, {
      responseType: 'arraybuffer',
    })
    .then((response) => {
      const redirect = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = redirect;
      link.setAttribute('download', `${documentName}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success(`Fazendo Download do ${documentName}...`);
      thenCallBack();
    })
    .catch((error) => {
      toast.error(`Erro ao Fazer Download do ${documentName}`);
      console.log(error);
    });

export const PdfOrErrorMessage = async (url, documentName, thenCallBack) =>
  api
    .get(url, {
      responseType: 'arraybuffer',
    })

    .then((response) => {
      const redirect = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = redirect;
      link.setAttribute('download', `${documentName}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success(`Fazendo Download do ${documentName}...`);
      thenCallBack();
    })

    .catch((error) => {
        toast.error(
        <>
          Possivelmente o relatório gerado <u>excedeu a capacidade</u> do sistema. Por favor, <u>refine a pesquisa</u> e tente novamente.
          <br /><br />
          Erro ao Fazer Download do <i>{documentName}</i>.
        </>
        );
        console.error(error);
    })
